import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import LOGO_BI from "../../assets/logo_bi.png";
import LOGO_WORKFLOW from "../../assets/logo_workflow.png";
import NotificacaoBell from "./NotificacaoBell";
import './styles.css'

export default function Navbar({ items = [], homePath = "/", workflows = false }) {
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const menuRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        openMenu &&
        menuRefs.current[openMenu] &&
        !menuRefs.current[openMenu].contains(e.target)
      ) {
        setOpenMenu(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openMenu]);

  const inicio = () => {
    navigate(homePath);
  };


  return (
    <>
      <nav className={`nav-root${scrolled ? " scrolled" : ""}`}>
        <div className="nav-inner">
          {/* Logo */}
          <div className="nav-logo" onClick={inicio}>
            <img src={workflows ? LOGO_WORKFLOW : LOGO_BI} alt="Logo Mydash" />
          </div>

          {/* Desktop */}
          <div className="nav-desktop">
            {items.map((item, idx) => (
              <div key={idx} style={{ display: "contents" }}>

                <div
                  ref={(el) => (menuRefs.current[item.label] = el)}
                  style={{ position: "relative", display: item.visible ? "none" : undefined }}
                >
                  <MenuDropdown
                    item={item}
                    open={openMenu === item.label}
                    toggle={() => {
                      if (item.command) {
                        item.command();
                      } else {
                        setOpenMenu(openMenu === item.label ? null : item.label);
                      }
                    }}
                    close={() => setOpenMenu(null)}
                    navigate={navigate}
                  />
                </div>
              </div>
            ))}
            <NotificacaoBell />
          </div>

          {/* Mobile hamburger */}
          <button
            className="nav-hamburger"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <i className={`fas fa-${mobileOpen ? "times" : "bars"}`} style={{ fontSize: 16 }} />
          </button>
        </div>

        {/* Mobile drawer */}
        {mobileOpen && (
          <div className="mobile-drawer">
            {items.map((item, idx) => (
              <div key={idx}>
                <MenuMobileGroup
                  item={item}
                  open={openMenu === item.label}
                  toggle={() =>
                    setOpenMenu(openMenu === item.label ? null : item.label)
                  }
                  navigate={navigate}
                  closeMobile={() => setMobileOpen(false)}
                />
              </div>
            ))}
          </div>
        )}
      </nav>
    </>
  );
}

function MenuDropdown({ item, open, toggle, close, navigate }) {
  const Icon = item.icon;

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={toggle}
        className={`nav-btn${open ? " active" : ""}`}
      >
        {Icon && <Icon className="nav-icon" />}
        {item.label}
        {item.items && (
          <i className={`fas fa-chevron-down chevron`} />
        )}
      </button>

      {open && item.items && (
        <div className="dropdown-panel">
          {item.items.map((sub, idx) => {
            const IconSub = sub.icon;
            const isLast = idx === item.items.length - 1;
            const prevIsGroup = idx > 0 && item.items[idx - 1]?.items;

            return (
              <div key={idx}>
                {prevIsGroup && <div className="dd-divider" />}
                {sub.items ? (
                  <SubMenu item={sub} navigate={navigate} close={close} />
                ) : (
                  <button
                    className="dd-item"
                    onClick={() => {
                      close();
                      sub.command ? sub.command() : navigate(sub.path);
                    }}
                  >
                    {IconSub && <IconSub className="nav-icon" />}
                    {sub.label}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function SubMenu({ item, navigate, close }) {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const Icon = item.icon;

  const handleOpen = () => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  };

  const handleClose = () => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 100); // delay evita fechar instantaneamente
  };

  return (
    <div
      style={{ position: "relative" }}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="dd-item"
        style={{ justifyContent: "space-between" }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {Icon && <Icon className="nav-icon" />}
          {item.label}
        </span>

        <i className="fas fa-chevron-right chevron-right" />
      </button>

      {open && (
        <div className="sub-panel">
          {item.items.map((child, idx) => {
            const IconSub = child.icon;

            return (
              <button
                key={idx}
                disabled={child.disabled}
                onClick={() => {
                  close();
                  child.command
                    ? child.command()
                    : navigate(child.path);
                }}
                className="dd-item"
                style={
                  child.disabled
                    ? {
                      color: "#b0b8c4",
                      pointerEvents: "none",
                    }
                    : {}
                }
              >
                {IconSub && <IconSub className="nav-icon" />}
                {child.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function MenuMobileGroup({ item, navigate, closeMobile }) {
  const [open, setOpen] = useState(false);
  const Icon = item.icon;

  const handleToggle = () => setOpen((prev) => !prev);

  return (
    <div style={{ width: "100%" }}>
      <button className="mob-btn" onClick={handleToggle}>
        <span>
          {Icon && <Icon style={{ width: 15, height: 15, opacity: 0.7 }} />}
          {item.label}
        </span>
        {item.items && (
          <i
            className={`fas fa-chevron-${open ? "up" : "down"}`}
            style={{ fontSize: 10, opacity: 0.45 }}
          />
        )}
      </button>

      {open && item.items && (
        <div className="mob-children">
          {item.items.map((sub, idx) => {
            const IconSub = sub.icon;
            return sub.items ? (
              <MenuMobileGroup
                key={idx}
                item={sub}
                navigate={navigate}
                closeMobile={closeMobile}
              />
            ) : (
              <button
                key={idx}
                disabled={sub.disabled}
                className="mob-leaf"
                onClick={() => {
                  sub.command ? sub.command() : navigate(sub.path);
                  closeMobile();
                }}
              >
                {IconSub && <IconSub style={{ width: 14, height: 14, opacity: 0.65 }} />}
                {sub.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
